var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{class:_vm.itemClasses},[_c('div',{class:_vm.tailClasses}),_c('div',{ref:"dot",class:_vm.headClasses,style:(_vm.customColor)},[_vm._t("dot")],2),_c('div',{class:_vm.contentClasses},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }